import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { notificationAPI } from '../services/api';
import { useAuth } from './AuthContext';

const NotificationCtx = createContext(null);
export const useNotifications = () => useContext(NotificationCtx);

export function NotificationProvider({ children }) {
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnread = useCallback(async () => {
    if (!user) return;
    try {
      const res = await notificationAPI.unreadCount();
      if (res.data.success) setUnreadCount(res.data.count);
    } catch (err) {
      console.error('Failed to fetch unread count:', err);
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      fetchUnread();
      const timer = setInterval(fetchUnread, 30000); // Poll every 30s
      return () => clearInterval(timer);
    } else {
      setUnreadCount(0);
    }
  }, [user, fetchUnread]);

  return (
    <NotificationCtx.Provider value={{ unreadCount, fetchUnread }}>
      {children}
    </NotificationCtx.Provider>
  );
}
